import { Directive, effect, ElementRef, inject, Renderer2, Signal } from '@angular/core'

import { Logger } from 'app/core/logger/logger'

import { SvgRegistry } from './svg-registry.service'

@Directive()
export abstract class SvgBaseDirective {
  private readonly elRef = inject<ElementRef<HTMLElement>>(ElementRef)
  private readonly renderer = inject(Renderer2)
  private readonly svgRegistry = inject(SvgRegistry)
  protected abstract readonly logger: Logger
  protected abstract readonly data: Signal<{ url: string; attrs?: Record<string, string> }>

  constructor() {
    effect(() => {
      const { url, attrs } = this.data()
      this.getAndSet(url, attrs)
    })
  }

  private getAndSet(url: string, attrs?: Record<string, string>) {
    this.svgRegistry
      .getFromUrl(url)
      .then(this.getSvgModifyFn(attrs))
      .then(this.setSvgElement)
      .catch((error: any) => this.logger.error(`Error retrieving svg for path ${url}`, error))
  }

  private getSvgModifyFn = (attrs?: Record<string, string>) =>
    attrs
      ? (svg: SVGElement): SVGElement => {
          Object.entries(attrs).forEach(([key, val]) => svg.setAttribute(key, val))
          return svg
        }
      : (svg: SVGElement) => svg
  private setSvgElement = (svg: SVGElement | null) => {
    const layoutElement = this.elRef.nativeElement
    // Remove existing child nodes and add the new SVG element.
    layoutElement.innerHTML = ''
    this.renderer.appendChild(layoutElement, svg)
  }
}
